module.exports = __webpack_public_path__ + "static/media/azDesc.84dfebcd.svg";